import TextInputSearch from "../../../../../common/components/atom/TextInputSearch/TextInputSearch";
import { useMeterV2 } from "../../../hooks/useMeter";
import { useSearchContext } from "../SearchContext";

export default function MeterV2SearchPresenter() {
    const { joulyMetersQuery: { setSearch, sreachValue, setPage } } = useMeterV2()
    const { setIsTyping } = useSearchContext();
    
    const callbackOnchange = (query: string) => {
        setPage(1);
        // Activer le loader immédiatement dès qu'il y a du texte
        const hasText = query.trim().length > 0;
        setIsTyping(hasText);
    }

    return (
        <TextInputSearch 
            placeholder={'Rechercher'} 
            sendQuery={(query) => {
                setSearch(query);
                // Désactiver le loader quand la recherche est envoyée (après le timeout)
                // Le loader restera actif pendant le timeout grâce à setIsLoading dans TextInputSearch
            }}
            valueInit={sreachValue} 
            onChangeCallback={callbackOnchange}
            timeout={3000}
            setIsLoading={setIsTyping}
        />
    )
}

